export const styles = theme => ({
    basketContainer: {
        flexGrow: 1,
        display: "block",
        marginBottom: 100,
    },
    table: {
        backgroundColor: "white"
    },
    tableHeader: {
        backgroundColor: "#f0f0f0"
    },
    teaserImage: {
        flexGrow: 1,
        width: "100%",
    },
    title: {
        "& h3": {
            margin: "1.5rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
        "& h5": {
            margin: "0.7rem 0"
        },
        "& h6": {
            margin: "0.7rem 0"
        },
    },
    stepsButtons: {
        marginTop: "30px",
        float: "right" as const
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
    instruction: {
        margintop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    userCardSmall: {
        backgroundColor: "white",
        height: 165,
        marginBottom: theme.spacing(1)
    },
    consent: {
        margin: theme.spacing(1),
        marginBottom: theme.spacing(5)
    },
    link: {
        color: '#000099'
    },
    cellHead: {
        backgroundColor: "#F0F0F0"
    },
    comment: {
        width: 500,
    },
    bold: {
        fontWeight: 900,
    },
    bottomMargin: {
        marginBottom: theme.spacing(2)
    },
    topMargin: {
        marginTop: theme.spacing(2)
    },
    rootStep: {
        display: "block",
        color: "#EEEEEE",
        fill: "currentColor"
    },
    text: {
        height: "16px",
        width: "24.1px",
        color: "#9E9E9E",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "14px"
    },
    active: {
        color: "#000099",
        "& text": {
            color: "white",
            fontWeight: 1000
        }
    },
    completed: {
        height: "24px",
        width: "24px",
        border: "1px solid #000099",
        borderRadius: "50%",
        color: "white",
        "& text": {
            color: "#000099",
            fontWeight: 1000
        }
    },
    stepper: {
        backgroundColor: "white",
        marginBottom: 50
    },
    sectionHeadline: {
        marginBottom: theme.spacing(3)
    },
    creditCardContainer: {
        borderRadius: "5px",
        backgroundColor: "#f2f2f2",
        padding: "20px"
    },
    paymentError: {
        color: "red"
    },
    stepContent: {
        width:"100%"
    },
    stepContainer: {
        display: "flex"
    },
    paymentLogo: {
        marginLeft: 10
    },
    unavailableProduct: {
        color: "red"
    }
});
